<template>
    <categ_node_product
        :max_depth="4"
        @set_active="set_active"
        @set_active_default="set_active_default"
        :categories="categories">
    </categ_node_product>
</template>

<script>

const collectNodes = (xs) =>
	xs .flatMap (({id, is_selected_main,is_selected, children = []}) => [
		{id, is_selected_main, is_selected},
		... collectNodes (children)
	]);

import categ_node_product from "../sub/categ_node_product";
export default {
	name: "categlist_product",
	props : {
		categories : {
			type : Array
		},
	},
    components : {
	    categ_node_product
    },

	data() {
		return  {
			categs:[]
		}
	},

	mounted() {
		this.categs = Vue.util.extend([], this.categories);
	},

	methods : {
		set_active_default(categ) {

			//is_selected_prod_main
			categ.is_selected_main = !categ.is_selected_main;
			let cur_state = categ.is_selected_main;
			this.disable_main_categ(this.categories,cur_state,parseInt(categ.id));

			this.$emit('change',this.get_active_categs);
		},

		set_active(categ) {
            categ.is_selected = !categ.is_selected;
			if(categ.is_selected === false) {
				categ.is_selected_main = false;
			}

			this.$emit('change',this.get_active_categs);
		},

		disable_main_categ(categs,cur_state,skeep_id) {
			let self = this;
			categs.map(item => {
				if(cur_state === true && parseInt(item.id) === skeep_id) {
					item.is_selected_main = true;

					if(item.is_selected === false) {
						item.is_selected = true;
					}
				}

				if(cur_state === false || (cur_state === true && parseInt(item.id) !== skeep_id)) {
					item.is_selected_main = false;
				}

				if(item.hasOwnProperty("children") && item.children.length > 0) {
					self.disable_main_categ(item.children,cur_state,skeep_id);
				}
			})
		},
	},

	computed : {
		get_active_categs() {
			let res = collectNodes(this.categories);
			if(res.length > 0) {
				return res.filter(item => {
					return item.is_selected === true;
				});
			}

			return [];
		},
	},
}
</script>

<style scoped>

</style>
